// Shared status model for the KpiCard metric tiles.
// Consumed by both the Statistics and the Evolution metric rows so their
// Green / orange / red / neutral performance colouring stays in sync.

// Status thresholds — see Figma D3a.
export const GRADE_RATIO_GREEN = 0.80
export const GRADE_RATIO_ORANGE = 0.40
export const SATISFACTION_GREEN = 80
export const SATISFACTION_ORANGE = 40

export const STATUS = {
  GREEN: 'green',
  ORANGE: 'orange',
  RED: 'red',
  NEUTRAL: 'neutral'
}

const numberFormatter = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 })
const integerFormatter = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 })

export const formatNumber = value => Number.isFinite(value) ? numberFormatter.format(value) : '--'
export const formatInteger = value => Number.isFinite(value) ? integerFormatter.format(value) : '--'
export const formatPercent = value => Number.isFinite(value) ? `${Math.round(value)} %` : '--'

export const gradeStatus = (grade, gradeMax) => {
  if (!Number.isFinite(grade) || !Number.isFinite(gradeMax) || gradeMax <= 0)
    return STATUS.NEUTRAL
  const ratio = grade / gradeMax
  if (ratio > GRADE_RATIO_GREEN)
    return STATUS.GREEN
  if (ratio >= GRADE_RATIO_ORANGE)
    return STATUS.ORANGE
  return STATUS.RED
}

export const satisfactionStatus = value => {
  if (!Number.isFinite(value))
    return STATUS.NEUTRAL
  if (value > SATISFACTION_GREEN)
    return STATUS.GREEN
  if (value >= SATISFACTION_ORANGE)
    return STATUS.ORANGE
  return STATUS.RED
}

export const alertStatus = count => count >= 1 ? STATUS.ORANGE : STATUS.NEUTRAL

// Status colouring uses the Evolution design-system palette (primary/progress/danger/neutral).
export const STATUS_TEXT_CLASS = {
  [STATUS.GREEN]: 'tw:text-ds-primary-high',
  [STATUS.ORANGE]: 'tw:text-ds-progress',
  [STATUS.RED]: 'tw:text-ds-danger',
  [STATUS.NEUTRAL]: 'tw:text-ds-neutral-high'
}

export const STATUS_BG_CLASS = {
  [STATUS.GREEN]: 'tw:bg-ds-primary-lowest',
  [STATUS.ORANGE]: 'tw:bg-ds-progress-lowest',
  [STATUS.RED]: 'tw:bg-ds-danger-lowest',
  [STATUS.NEUTRAL]: 'tw:bg-ds-neutral-lowest'
}
